import React, { useState } from 'react';
import { X, Plus, Trash2, Check, X as XIcon, Edit3 } from 'lucide-react';

const BatchCourseModal = ({
  isOpen,
  onClose,
  courses,
  onBatchAdd,
  onBatchDelete,
  onEditCourse
}) => {
  const [batchInput, setBatchInput] = useState('');
  const [selectedCourses, setSelectedCourses] = useState([]);

  if (!isOpen) return null;

  const handleBatchAdd = () => {
    const courseNames = batchInput
      .split('\n')
      .map(name => name.trim())
      .filter(name => name && !courses.some(c => c.name === name));
    
    if (courseNames.length > 0) {
      onBatchAdd(courseNames);
      setBatchInput('');
    }
  };

  const handleCourseSelect = (courseName) => {
    setSelectedCourses(prev => 
      prev.includes(courseName) 
        ? prev.filter(name => name !== courseName)
        : [...prev, courseName]
    );
  };

  const handleBatchDelete = () => {
    if (selectedCourses.length > 0) {
      onBatchDelete(selectedCourses);
      setSelectedCourses([]);
    }
  };

  const handleSelectAll = () => {
    setSelectedCourses(courses.map(c => c.name));
  };

  const handleClearSelection = () => {
    setSelectedCourses([]);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-6xl relative" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100 z-10 flex items-center justify-center"
        >
          <X size={18} />
        </button>

        <div className="modal-header">
          <h3 className="text-lg font-semibold text-gray-900">批量课程管理</h3>
        </div>

        <div className="modal-body">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* 左侧：批量添加课程 */}
            <div className="space-y-4">
              <h4 className="text-md font-medium text-gray-800">批量添加课程</h4>
              <div className="space-y-3">
                <textarea
                  value={batchInput}
                  onChange={(e) => setBatchInput(e.target.value)}
                  placeholder="请输入课程名称，每行一个，例如：&#10;语文&#10;数学&#10;英语&#10;物理&#10;化学"
                  rows="8"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg text-sm transition-colors duration-300 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200"
                />
                <div className="flex gap-2">
                  <button className="btn btn-success" onClick={handleBatchAdd}>
                    <Plus size={16} className="mr-2" />
                    批量添加
                  </button>
                  <button className="btn btn-warning" onClick={() => setBatchInput('')}>
                    <XIcon size={16} className="mr-2" />
                    清空输入
                  </button>
                </div>
              </div>
            </div>

            {/* 右侧：课程列表管理 */}
            <div className="space-y-4">
              <h4 className="text-md font-medium text-gray-800">课程列表管理</h4>
              <div className="space-y-3">
                <div className="max-h-64 overflow-y-auto border border-gray-200 rounded-lg p-3">
                  <div className="space-y-2">
                    {courses.map((course, index) => (
                      <div
                        key={index}
                        className={`flex items-center gap-3 p-2 rounded-lg transition-colors duration-200 ${
                          selectedCourses.includes(course.name) 
                            ? 'bg-primary-50 border border-primary-200' 
                            : 'hover:bg-gray-50'
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={selectedCourses.includes(course.name)}
                          onChange={() => handleCourseSelect(course.name)}
                          className="w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
                        />
                        <span className="flex-1 text-sm font-medium text-gray-700">
                          {course.name}
                        </span>
                        <div
                          className="w-4 h-4 rounded-full border border-gray-300"
                          style={{ backgroundColor: course.color }}
                        />
                        {onEditCourse && (
                          <button
                            onClick={() => onEditCourse(course)}
                            className="p-1 text-gray-400 hover:text-primary-600 transition-colors duration-200"
                            title="编辑课程详情"
                          >
                            <Edit3 size={14} />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="flex gap-2">
                  <button className="btn btn-danger" onClick={handleBatchDelete}>
                    <Trash2 size={16} className="mr-2" />
                    删除选中
                  </button>
                  <button className="btn btn-warning" onClick={handleSelectAll}>
                    <Check size={16} className="mr-2" />
                    全选
                  </button>
                  <button className="btn btn-secondary" onClick={handleClearSelection}>
                    <XIcon size={16} className="mr-2" />
                    取消全选
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            <Check size={16} className="mr-2" />
            完成
          </button>
        </div>
      </div>
    </div>
  );
};

export default BatchCourseModal;